import { LanguageCode, SUPPORTED_LANGUAGES } from '../i18n/languages';
import { hasPublicTranslation, pubPath } from '../i18n/publicTranslation';
import * as sourceConfig from './routeConfig';
// One source of page structure and facts. Public copy is translated at render time.
export const getLanguageRouteConfig = (_language: LanguageCode) => sourceConfig;
export const getLanguageRoutePaths = (_language: LanguageCode) => sourceConfig.getAllRoutePaths();
export const getLanguageRouteConfigByPath = (_language: LanguageCode, path: string) => sourceConfig.getRouteConfig(path);
// These are HomePage variants. Other translated public routes use their own page components.
export const getAllLocalizedRoutes = () => Object.keys(SUPPORTED_LANGUAGES).flatMap(language => sourceConfig.getAllRoutePaths().map(path => ({
    lang: language as LanguageCode,
    path,
    fullPath: pubPath(path, language as LanguageCode),
})));
export const routeExistsInLanguage = (_language: LanguageCode, path: string) => hasPublicTranslation(path);
export const getAlternateLanguageUrls = (path: string, baseUrl = 'https://thefableapp.com') => hasPublicTranslation(path) ? Object.keys(SUPPORTED_LANGUAGES).map(language => ({
    lang: language as LanguageCode,
    url: baseUrl + pubPath(path, language as LanguageCode),
})) : [];
